// import "@progress/kendo-ui/css/web/kendo.common.less";
// import "@progress/kendo-ui/css/web/kendo.materialblack.less";

import { StateProvider } from '@uirouter/angularjs';
import { LogsController } from './logs.controller';
import { HeaderService, HEADER_SERVICE } from './../core/header.service';
import { registerComponentFromTransition } from "../core/lazy-route.helper";
import { APP_SHELL_STATE } from "../app-shell.route";

export const OS_EVENTS_LOGS_STATE = "osevenlogststate";

export function configRoute($stateProvider: StateProvider) {
    $stateProvider.state(OS_EVENTS_LOGS_STATE, {
        parent: APP_SHELL_STATE,
        url: "/logs",
        views: {
            content: {
                component: "logsComponent"
            }
        },
        lazyLoad: async (transition, state) => {
            const moduleExport: any = await import("./logs.component");
            registerComponentFromTransition(transition, "logsComponent", moduleExport.logsComponentOptions);
            return moduleExport;
        },
        onEnter: [HEADER_SERVICE, (headerService: HeaderService) => {
            headerService.headerTitle = "Operating system events";
        }]
    });
}
configRoute.$inject = ["$stateProvider"];



// WEBPACK FOOTER //
// ./app/logs/logs.router.ts